package link.erpango.quip.utils

actual val isDebugBuild: Boolean = js("process.env.NODE_ENV !== 'production'") as Boolean
